export function getParams (state){
    return state.params
}